import styled from 'styled-components';

export const CabHourlyCarousel = styled.div`
  border-radius: 12px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SliderArrow = styled.button`
  width: 4rem;
  height: 4rem;
  display: flex;
  border-radius: 50%;
  background-color: white;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
  border:none;
  outline: 0;
  &.right {
    top: 50%;
    right: -1rem;
    transform: translateY(-50%);
  }
  &.left {
    top: 50%;
    left: -1rem;
    transform: translateY(-50%);
  }
`;
